import type { TruncationMode } from '@dynatrace/strato-components/typography';

import { getTruncationMethod } from './get-truncation-method.js';
import { measureNodeTextContent } from './measure-node-text-content.js';
import { renderTextToCanvas } from './render-text-to-canvas.js';
import { getColorByContrast } from '../../../../core/utils/color-contrast.js';
import { HONEYCOMB_DEFAULT_TEXT_ALIGNMENT } from '../../../constants.js';
import { CanvasTextAreaProps } from '../../../types/canvas-text-area.js';

const topAndBottomPadding = 2;

export const drawLabelAndValue = (
  ctx: CanvasRenderingContext2D,
  value: string | number,
  textArea: CanvasTextAreaProps,
  backgroundColor: string,
  name: string = '',
  truncationMode: TruncationMode = 'middle',
) => {
  const { x, y } = textArea;
  const cropNameToFit = getTruncationMethod(
    ctx,
    textArea,
    name,
    truncationMode,
  );
  const cropValueToFit =
    typeof value === 'string'
      ? getTruncationMethod(ctx, textArea, value, truncationMode, 'value')
      : () => value.toString();

  const {
    valueHeight,
    nameHeight,
    ableToRenderNothing,
    ableToRenderBoth,
    valueWidth,
    nameWidth,
    ableToRenderName,
    ableToRenderValue,
  } = measureNodeTextContent(ctx, value, name, textArea);

  if (ableToRenderNothing) {
    return;
  } else {
    const textColor = getColorByContrast(backgroundColor);
    ctx.textAlign = HONEYCOMB_DEFAULT_TEXT_ALIGNMENT;
    ctx.fillStyle = textColor;

    const availableWidth = textArea.width - topAndBottomPadding * 2;
    const renderedName = availableWidth > nameWidth ? name : cropNameToFit();
    const renderedValue =
      availableWidth >= valueWidth ? value.toString() : cropValueToFit();
    if (ableToRenderBoth) {
      renderTextToCanvas(ctx, renderedName, 'label', x, y - 2);
      const valueY = y + nameHeight + nameHeight * 0.5;
      renderTextToCanvas(ctx, renderedValue, 'value', x, valueY);
    } else if (ableToRenderName) {
      const nameCenteredY = y + nameHeight / 2;
      renderTextToCanvas(ctx, renderedName, 'label', x, nameCenteredY);
    } else if (ableToRenderValue) {
      const valueCenteredY = y + valueHeight / 2;
      availableWidth > valueWidth &&
        renderTextToCanvas(ctx, renderedValue, 'value', x, valueCenteredY);
    }
  }
};
